import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	user: false,
	isLoading: true,
	errorMessage: "",
};

export default function authReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.AUTH_STATUS_CHANGED:
			return Object.assign({}, state, {
				user: action.user,
				isLoading: false,
			});
		case ActionTypes.LOGOUT_USER:
			return Object.assign({}, state, {
				user: null,
			});
		case ActionTypes.LOGIN_ERROR:
			return Object.assign({}, state, {
				errorMessage: action.message,
				isLoading: false,
			});
		default:
			return state;
	}
}
